module.exports = __webpack_public_path__ + "img/payroll.ffe315c6.svg";